import React from "react";
import ReactDOM from "react-dom/client";
import { HashRouter, Routes, Route } from "react-router-dom";
import Login from "./App";
import Signup from "./pages/Signup";
// import "./index.css";
import Home from "./pages/Home";
import Dashboard from "./pages/Dashboard";
import ProfilePage from "./pages/Profile";
import ChallengesPage from "./pages/Challenges";
import Mappage from "./pages/map";
import UserSettings from "./pages/Settings";
import ForgotPassword from "./pages/ForgotPassword";
import ProtectedRoute from "./components/ProtectedRoute";

import GroupDashboard from "./pages/GroupDashboard";
import HotStepperHub from "./pages/HotStepperHub";

export default function App() {
  return (
    <HashRouter>

       <Routes>

        <Route index element={<Login />} />
        <Route path="login" element={<Login />} />
        <Route path="signup" element={<Signup />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
        {/* <Route path="home" element={<Home />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path='profile' element={<ProfilePage />} />
        <Route path="challenges" element={<ChallengesPage />} />
        <Route path="map" element={<Mappage />} />
        <Route path="settings" element={<UserSettings />} /> */}
        {/* Protected Routes */}
        <Route
          path="home"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />
        <Route
          path="dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="profile"
          element={
            <ProtectedRoute>
              <ProfilePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="challenges"
          element={
            <ProtectedRoute>
              <ChallengesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="map"
          element={
            <ProtectedRoute>
              <Mappage />
            </ProtectedRoute>
          }
        />
        <Route
          path="settings"
          element={
            <ProtectedRoute>
              <UserSettings />
            </ProtectedRoute>
          }
        />
    

       <Route
          path="group-dashboard"
          element={
            <ProtectedRoute>
              <GroupDashboard />
            </ProtectedRoute>
          }
        />

         <Route
          path="stepper-hub"
          element={
            <ProtectedRoute>
              <HotStepperHub />
            </ProtectedRoute>
          }
        />

        </Routes>

    </HashRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);